import React, { useEffect, useRef } from 'react';

const AutoGrowTextarea: React.FC<{
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  minHeight?: number;
  className?: string;
  textareaRef?: React.RefObject<HTMLTextAreaElement | null>;
  onFocus?: () => void;
  /** Fires on any selection change (including collapse) while the textarea is focused. */
  onSelect?: React.ReactEventHandler<HTMLTextAreaElement>;
}> = ({ value, onChange, disabled, placeholder, minHeight = 72, className, textareaRef, onFocus, onSelect }) => {
  const internalRef = useRef<HTMLTextAreaElement | null>(null);
  const ref = textareaRef ?? internalRef;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.max(minHeight, el.scrollHeight)}px`;
  }, [value, minHeight, ref]);

  return (
    <textarea
      ref={ref}
      className={[
        'w-full resize-none overflow-hidden rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900',
        'focus:border-primary-500 focus:ring-primary-500 disabled:bg-gray-50',
        className || '',
      ].join(' ')}
      style={{ minHeight }}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onFocus={onFocus}
      onSelect={onSelect}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default AutoGrowTextarea;
